import { render, staticRenderFns } from "./DriverInvoiceDetail.vue?vue&type=template&id=7ed70532&scoped=true&"
import script from "./DriverInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./DriverInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverInvoiceDetail.vue?vue&type=style&index=0&id=7ed70532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed70532",
  null
  
)

export default component.exports